<template>
  <div :class="isMobile ? 'productDetail-m' : 'productDetail'">
    <el-breadcrumb separator="/" class="bread">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/product' }">产品</el-breadcrumb-item>
      <el-breadcrumb-item>产品详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="part" v-if="isShow">
      <el-col :span="isMobile ? 24 : 8" class="imgPart">
        <img class="bigImg" :src="require(`./../../assets/project/${thisObj.imgUrl}`)" />
      </el-col>
      <el-col :span="isMobile ? 22 : 14" :offset="isMobile ? 0 : 2">
        <div>
          <div class="title">{{thisObj.name}}</div>
          <div v-for="(item, index) in thisObj.introduction" :key="index">
            <div class="subtitle">{{ item.name }}</div>
            <div v-show="item.text" class="text" v-for="(obj, i) in item.text" :key="i">{{obj}}</div>
            <el-table
              v-if="item.table"
              :data="item.table.body"
              border
              style="width: 100%">
              <el-table-column
                v-for="(obj, i) in item.table.header"
                :prop="obj"
                :label="obj">
              </el-table-column>
            </el-table>
            <img style="max-width: 100%" v-if="item.imgUrl" 
              :src="require(`./../../assets/project/detail/${item.imgUrl}`)"
              />
          </div>
          <a v-show="thisObj.taobaoHref" :href="thisObj.taobaoHref" target="_blank" class="toPdf">淘宝购买</a>
          <a v-show="thisObj.href" :href="thisObj.href" target="_blank" class="toPdf">产品说明书</a>
          <div class="connectMethod">
            <img class="icon" src="./../../assets/homeIcon/phone-small.png" />
            <span class="phone">15255615034</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="detail">
      <div v-for="(item, index) in thisObj.detail" :key="index">
        <div class="subtitle">{{ item.name }}</div>
        <div v-show="item.text" class="text" v-for="(obj, i) in item.text" :key="i">{{obj}}</div>
        <el-table
          v-if="item.table"
          :data="item.table.body"
          border
          style="width: 100%">
          <el-table-column
            v-for="(obj, i) in item.table.header"
            :prop="obj"
            :label="obj">
          </el-table-column>
        </el-table>
        <img style="max-width: 100%" v-if="item.imgUrl" 
          :src="require(`./../../assets/project/detail/${item.imgUrl}`)"
          />
      </div>
    </div>
  </div>
</template>

<script>
import arrJson from "../../utils/arrJson"
export default {
  name: 'ProdectDetail',
  data() {
    return {
      isMobile: window.innerWidth < 780,
      id: null,
      isShow: false,
      thisObj: {}
    }
  },
  mounted() {
    this.getDetail()
    window.addEventListener("resize", this.initFunc)
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
  methods: {
    getDetail() {
      let parentId = null
      const pathList = this.$router.currentRoute.path.split("/") // 取url上的id
      this.id = pathList[pathList.length-1]
      parentId = this.id.split("")[1] //取父级index，“012”，父级为“1”
      const index = arrJson.productList[parentId].data.findIndex(item => item.id+""===this.id+"")
      this.thisObj = arrJson.productList[parentId].data[index]
      this.isShow = true
    },
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  },
  props: {
    msg: String
  }
}
</script>


<style scoped lang="less">
  /deep/ .el-breadcrumb__inner.is-link{
    font-weight: normal;
  }
  .productDetail{
    max-width: 1100px;
    margin: 0 auto 60px;
    .bread{
      line-height: 50px;
      margin-top: 20px;
    }
    .part{
      text-align: left;
      .imgPart{
        background: #d6dde8;
        text-align: center;
      }
      .bigImg{
        max-width: 100%;
        max-height: 400px;
        display: block;
        margin: 0 auto;
      }
      .title{
        font-size: 26px;
        line-height: 40px;
      }
      .subtitle{
        font-size: 16px;
        color: #244c6e;
        font-weight: bold;
        line-height: 40px;
        margin-top: 20px;
      }
      .text{
        font-size: 16px;
        line-height: 30px;
        text-align: left;
        color: #6f6f6f;
        text-indent: 32px;
      }
      .toPdf{
        font-size: 14px;
        color: #fff;
        display: inline-block;
        border-radius: 20px;
        padding: 12px 40px;
        margin: 16px 10px 0 0;
        background: #384C5C;
        cursor: pointer;
      }
      .connectMethod{
        padding: 0 0 0 12px;
        display: inline-block;
        vertical-align: sub;
        margin-top: 20px;
        .icon{
          width: 20px;
          height: 20px;
        }
        .phone{
          color: #00d0ff;
          line-height: 22px;
          display: inline-block;
          vertical-align: top;
          margin-left: 4px;
          font-size: 18px;
        }
      }
    }
    .detail{
      text-align: center;
      .subtitle{
        font-size: 16px;
        color: #244c6e;
        font-weight: bold;
        line-height: 40px;
        margin-top: 20px;
        text-align: left;
      }
      .text{
        font-size: 16px;
        line-height: 30px;
        text-align: left;
        color: #6f6f6f;
        text-indent: 32px;
      }

    }
  }
  .productDetail-m{
    margin: 0 0.4rem 1rem;
    /deep/ .el-breadcrumb{
      font-size: 0.4rem;
    }
    .bread{
      line-height: 1.2rem;
    }
    .part, .detail{
      text-align: left;
      .imgPart{
        padding: 0.1rem;
        background: #d6dde8;
        text-align: center;
      }
      .bigImg{
        max-width: 90%;
        max-height: 10rem;
        display: block;
        margin: 0 auto;
      }
      .title{
        font-size: 0.46rem;
        line-height: 0.9rem;
        margin-top: 0.4rem;
      }
      .subtitle{
        font-size: 0.38rem;
        color: #244c6e;
        font-weight: bold;
        line-height: 0.6rem;
        margin-top: 0.6rem;
      }
      .text{
        font-size: 0.38rem;
        line-height: 0.7rem;
        text-align: left;
        color: #6f6f6f;
        text-indent: 0.7rem;
      }
      .toPdf{
        font-size: 0.3rem;
        color: #fff;
        display: inline-block;
        border-radius: 0.4rem;
        padding: 0.24rem 0.8rem;
        margin: 0.32rem 0.32rem 0 0;
        background: #384C5C;
      }
      .connectMethod{
        .icon{
          width: 0.4rem;
          height: 0.4rem;
        }
        .phone{
          color: #00d0ff;
          display: inline-block;
          margin-left: 0.12rem;
          font-size: 0.36rem;
        }
      }
    }
  }


</style>